module.exports = __webpack_public_path__ + "static/img/bg-01-lg_2025.7b71d09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-01-lg_2025.jpg
// module id = eWle
// module chunks = 100